import TplConfigApi from '../../api/template-config.api'

const state = {

}
const getters = {
	filterCombo: (state, getters, rootState) => {
		let user = {
			combo: '',
			count: ''
		}
		if (!rootState.user.user) {
			return user
		}
		let combo = rootState.user.user.role || 'user'
		switch (combo) {
		case 'user':
			user.combo = '注册用户'
			user.count = '1'
			break
		case 'vip':
			user.combo = '基础版'
			user.count = '3'
			break
		case 'vip1':
			user.combo = '1星版'
			user.count = '无限'
			break
		case 'vip2':
			user.combo = '2星版'
			user.count = '无限'
			break
		case 'vip3':
			user.combo = '3星版'
			user.count = '无限'
			break
		}
		return user
	}
}
const mutations = {

}
const actions = {
	checkDomain({
		state
	}, params) {
		return TplConfigApi.checkDomain(params)
	},
	cyberDomain({
		state
	}, params) {
		return TplConfigApi.cyberDomain(params)
	},
	checkMineDomain({
		state
	}, params) {
		return TplConfigApi.checkMineDomain(params)
	},
	bindMineDomain({
		state
	}, params) {
		return TplConfigApi.bindMineDomain(params)
	},
	getSkin({
		state
	}, params) {
		return TplConfigApi.getSkin(params)
	},
	saveBestskin({
		state
	}, params) {
		return TplConfigApi.saveBestskin(null, params)
	},

	saveSkin({
		state
	}, params) {
		return TplConfigApi.saveSkin(null, params)
	},
	saveConfigInfo(context, data) {
		return TplConfigApi.saveConfigInfo(data)
	},

	publishProj(context, params) {
		return TplConfigApi.publishProj(params)
	},
	getProgress(context, params) {
		return TplConfigApi.getProgress(params)
	},

	/**
	 * 获取搜索引擎抓取页面数量
	 * @param params
	 * @returns {*}
	 */
	getSearchNumber(context, params) {
		return TplConfigApi.getSearchNumber(params)
	},
	uploadIco(context, data) {
		return TplConfigApi.uploadIco(data)
	},
	getCommonInfo(context) {
		return TplConfigApi.getCommonInfo()
	},
	setProjSeo(context, data) {
		return TplConfigApi.setProjSeo(data)
	},
	getRobotsDomain(context, data) {
		return TplConfigApi.getRobotsDomain(data)
	}
}

export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true
}
